(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trades_directory"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('.trade-gallery img').forEach(i=>i.loading='lazy');});

  } catch(e) { console.error(e); }
})();
})();
